// 物资返库申请单

const onStandardChangeDlg = {
    namespaced: true,
  
    state: {
      dlgShow: false,
    },
  
    getters: {
      dlgShow: state => state.dlgShow,
    },
  
    mutations: {
      SET_DLGSHOW: (state, val) => {
        state.dlgShow = val
      },
    },
  
    actions: {
  
    }
  }
  
  export default onStandardChangeDlg
  